export const PushEvents = {
  // pusher actions
  CONNECTION_STATE_CHANGED: 'state_change',
  RETRY_CONNECTION: 'retry_connection',
  RESET_STORE: 'reset_store',
  USER: 'user',

  // desktop notification
  TEST_MESSAGE: 'test_message',

  // delivery updates
  CHANGESET_UPDATE_DELIVERY_UPDATES: 'changeset-update-delivery_updates',

  // chat message
  CHANGESET_CREATE_CHAT_MESSAGE: 'changeset-create-chat_message',

  // phone calls
  CHANGESET_UPDATE_PHONE_CALL: 'changeset-update-phone_call',

  // group
  CHANGESET_UPDATE_GROUP: 'changeset-update-group',
  CHANGESET_CREATE_GROUP: 'changeset-create-group',
  CHANGESET_DESTROY_GROUP: 'changeset-destroy-group',

  // unread
  CHANGESET_UPDATE_UNREADS: 'changeset-update-unreads',

  // chat
  CHANGESET_UPDATE_CHAT: 'changeset-update-chat',
  CHANGESET_UPDATE_CHATS: 'changeset-update-chats',

  // chat marker
  CHANGESET_UPDATE_CHAT_MARKER: 'changeset-update-chat_marker',

  // class memberships
  CHANGESET_CREATE_CLASSMEMBERSHIP: 'changeset-create-classmembership',
  CHANGESET_DESTROY_CLASSMEMBERSHIP: 'changeset-destroy-classmembership',
  // TODO remove v2 pusher event CLASS_MEMBERSHIP
  CLASS_MEMBERSHIP: 'classmembership',

  // devices
  CHANGESET_DESTROY_DEVICE: 'changeset-destroy-device',
  CHANGESET_UPDATE_DEVICE: 'changeset-update-device',
  CHANGESET_CREATE_DEVICE: 'changeset-create-device',

  // desktop notification
  CHANGESET_CREATE_DESKTOP_NOTIFICATION: 'changeset-create-desktop_notification',

  // user
  CHANGESET_UPDATE_USER: 'changeset-update-user',

  // reactions
  CHANGESET_UPDATE_CHAT_MESSAGE_REACTION: 'changeset-update-chat_message_reaction',
  CHANGESET_UPDATE_CHAT_BROADCAST_REACTION: 'changeset-update-chat_broadcast_reaction',
};
